import './FilterField.css'

export interface FilterFieldProps {
	value: string,
	label: string,
	icon?: string,
	onChange?: (newValue: string) => void
}

export const FilterField = ({ value, label, icon, onChange }: FilterFieldProps) => {

	return (
		<div className='filter-field'>
			<div className='filter-field-inner-wrapper'>
				<div className='filter-field-icon'>
					{icon && <img className='filter-field-icon-mask' src={icon} alt="" />}
				</div>
				<input className='filter-field-input' placeholder={label} type="text" value={value} onChange={(e) => onChange?.(e.target.value)} />
			</div>
		</div>
	)

}